import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ArticleService {

  constructor(private http: HttpClient) { }

  getArticle(ref: String) {
    return this.http.get<any>(environment.api.alpine.url + '/article/'+ ref);
  }
}
